import React from "react";
import { Redirect } from "react-router";
import { AppRouteUi } from "../config/appRoute";
import { useAppSelector } from "../core/redux";

export function RedirectToDefaultPageOnAuthorized(
  props: React.PropsWithChildren<{}>
): JSX.Element {
  const store = useAppSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
    role: state.auth.userRole,
  }));

  if (store.isLoggedIn && store.role)
    return <Redirect to={AppRouteUi.GetRouteByRole(store.role)} />;

  return <>{props.children ?? null}</>;
}
